import React, { useRef } from "react";

import { fetchHashtags } from "../../api/services/defs/hashtags";

import AsyncSelectInput from "../Inputs/AsyncSelectInput";
//components
import { Result } from "../Inputs/SelectInput";
import Spacer from "../Spacer";
import Typography from "../Text";

//services

interface HashtagPickerProps {
	/**
	 * current value of the hashtag picker
	 */
	value?: Result | Result[];

	/**
	 * function runs on HashtagPicker change
	 */
	onChange?: (value: any) => void;

	/**
	 * label for the hashtag picker
	 */
	label?: string;

	/**
	 * isMultiSelect determines if the hashtag picker is a single select or multi select
	 */
	isMultiSelect?: boolean;
}

const HashtagPicker = ({ value, onChange, label, isMultiSelect = false }: HashtagPickerProps) => {
	const currentlyFetchedHashtags = useRef<any[]>([]);

	const fetchOptions = async (inputValue: string) => {
		try {
			if (currentlyFetchedHashtags.current.length < 1) {
				const data = await fetchHashtags(inputValue);
				currentlyFetchedHashtags.current = data;
			}

			const fetchedHashtags = currentlyFetchedHashtags.current.map((hashtag) => {
				return {
					label: hashtag,
					value: hashtag,
				};
			});

			return inputValue
				? fetchedHashtags.filter((hashtag) => hashtag.label.toLowerCase().includes(inputValue.toLowerCase()))
				: fetchedHashtags;
		} catch (error) {
			throw new Error("Error fetching hashtags");
			return [];
		}
	};

	return (
		<div data-testid="HashtagPicker">
			{label ? (
				<>
					<Typography element="label" size="paragraph-3" weight="semi-bold">
						{label}
					</Typography>
					<Spacer height={1} />
				</>
			) : null}
			<AsyncSelectInput
				fetchOptions={fetchOptions}
				isMultiSelect={isMultiSelect}
				value={value}
				onChange={(hashtags) => {
					if (onChange && hashtags) {
						onChange(hashtags);
					}
				}}
			/>
		</div>
	);
};

export default HashtagPicker;
